module.exports = __webpack_public_path__ + "img/booking.5f753c75.svg";